import React, { useState } from 'react';
// Components
import RichTextRenderer from '../richTextRenderer';
// Interfaces
import { Text as TextInterface } from '../../interfaces/text';

interface FaqProps {
  faqType: string;
  question: TextInterface;
  answer: TextInterface;
  extraClasses: string;
}

function Faq({ faqType, question, answer, extraClasses }: FaqProps) {
  const faqTypeHandler = (type: string) => {
    switch (type) {
      case 'Accordion':
        return 'cl-faq--accordion';
      case 'Card':
        return 'cl-faq--card';
      default:
        return '';
    }
  };
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = () => {
    setIsOpen((current) => !current);
  };
  return (
    <div
      className={`cl-faq ${faqTypeHandler(faqType)} ${extraClasses ? extraClasses : ''} ${
        faqType === 'Accordion' ? (isOpen ? 'cl-faq--accordion-open' : '') : ''
      }`}
      onClick={handleClick}
    >
      <div className='cl-faq__question'>
        <RichTextRenderer text={question} />
      </div>
      <div className='cl-faq__answer'>
        <RichTextRenderer text={answer} />
      </div>
    </div>
  );
}

export default Faq;
